import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { GasStatusTagComponent } from './status-tag/status-tag.component';
import { GasStatusTagGroupComponent } from './group/group.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';


const COMPONENTS = [
  GasStatusTagComponent,
  GasStatusTagGroupComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GasIconsModule,
  ],
})
export class GasStatusTagModule { }
